// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__1sZDb","question":"styles_question__2Zgmi"};